import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { CatalogCreatePage } from '@/features/data/catalog/catalog-create-page';
import { ConsoleShell } from '@/features/shell/console-shell';

export const Route = createFileRoute('/$tenant/catalog/new')({ component: NewLayerRoute });

function NewLayerRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="catalog"
      crumbs={[{ label: t('nav.items.catalog') }, { label: t('data.catalog.new.layer') }]}
    >
      <CatalogCreatePage tenantId={tenant} parent={undefined} />
    </ConsoleShell>
  );
}
